export default __webpack_public_path__ + "static/media/information--hazardous-goods-vehicles-lane--g1.5d266d26.png";